import React, { useState, useRef, useEffect } from 'react';
import './filter.css';
import { useDispatch } from 'react-redux';
import { setOption } from '../../Redux/featuers/optionSlice';
function Filter1({ onOptionSelect }) {
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');


  useEffect(() => {
    // selectedOptionRef.current = selectedOption;
    // console.log(selectedOptionRef.current); // Console the selected option

    const handleOutsideClick = (event) => {
      if (!event.target.closest('.select-menu')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [selectedOption]);

  const toggleOptions = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    dispatch(setOption(option));
  };

  return (
    <div className="filter-box">
      <div className={`select-menu ${isOpen ? 'active' : ''}`}>
        <div className="select-btn" onClick={toggleOptions}>
          <span className="sBtn-text">Filter by</span>
          <svg role="img" viewBox="0 0 512 512">
            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
          </svg>
        </div>
        <ul className="options">
          <li className="option" onClick={() => handleSelect('PRICE')}>
            <span className="option-text">PRICE(Low to High)</span>
          </li>
          <li className="option" onClick={() => handleSelect('ML_BEST_VALUE')}>
            <span className="option-text">BEST VALUE</span>
          </li>
          <li className="option" onClick={() => handleSelect('DURATION')}>
            <span className="option-text">DURATION</span>
          </li>
          <li className="option" onClick={() => handleSelect('EARLIEST_OUTBOUND_DEPARTURE')}>
            <span className="option-text">EARLIEST DEPARTURE</span>
          </li>
          <li className="option" onClick={() => handleSelect('EARLIEST_OUTBOUND_ARRIVAL')}>
            <span className="option-text">EARLIEST ARRIVAL</span>
          </li>
          <li className="option" onClick={() => handleSelect('LATEST_OUTBOUND_DEPARTURE')}>
            <span className="option-text">LATEST DEPARTURE</span>
          </li>
          <li className="option" onClick={() => handleSelect('LATEST_OUTBOUND_ARRIVAL')}>
            <span className="option-text">LATEST ARRIVAL</span>
          </li>
          {/* Add more options here */}
        </ul>
      </div>
    </div>
  );
}

export default Filter1;
